module.exports = __webpack_public_path__ + "img/other_avatar.835f5201.jpeg";